export default "__VITE_ASSET__KY_lAFWx__"